export const COLOUR_HISTORY_REQUEST = "COLOUR_HISTORY_REQUEST";
export const COLOUR_HISTORY_SUCCESS = "COLOUR_HISTORY_SUCCESS";
export const COLOUR_HISTORY_FAILED = "COLOUR_HISTORY_FAILED";